var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('authentication-interceptor',[_c('accept-policies-interceptor',[_c('dossier-details',{attrs:{"dossier":_vm.dossier,"editable":true,"submitting":_vm.submitting,"canEditDossier":true,"selectedActivityId":_vm.activityId},on:{"cancel":_vm.goBack,"submit":_vm.submit,"lotAdded":_vm.lotAdded}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }